import { useQuery } from "@tanstack/react-query";
import { getCases } from "./services/airtable";

export function useCases({ practiceSlug, filterEmail, offset }) {
  const {
    isLoading: isLoadingCases,
    data: casesData,
    error,
  } = useQuery({
    queryKey: ["cases", practiceSlug, filterEmail, offset],
    queryFn: () => getCases({ practiceSlug, filterEmail, offset }),
  });

  return {
    isLoadingCases,
    cases: casesData?.cases || [],
    nextOffset: casesData?.offset,
    practiceUsersEmails: casesData?.practiceUsersEmails,
    error,
  };
}
